import * as PIXI from "pixi.js";
import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
/**
 * SpriteProperties.ts
 *
 * The pieces needed to find an individual sprite in a sprite sheet.
 *
 * {spriteSheet}-{"Landscape-" | "Portrait-" | "" }{id}
 *
 * Will automatically find Landscape and Portrait variants if those infixes are available.
 *
 */
export class SpriteProperties extends AbstractViewProperties {
    constructor(id, spriteSheet, position, scale, anchor, rotation) {
        super(position);
        this.id = id;
        this.spriteSheet = spriteSheet;
        this.scale = scale ?? new PIXI.Point(1, 1);
        this.anchor = anchor ?? new PIXI.Point(0, 0);
        this.rotation = rotation ?? 0;
    }
    equals(other) {
        return (super.equals(other) &&
            this.id === other.id &&
            this.spriteSheet === other.spriteSheet &&
            this.anchor.equals(other.anchor) &&
            this.rotation === other.rotation);
    }
}
//# sourceMappingURL=SpriteProperties.js.map